import { APIClient } from '@frontend/api-utils';
import { Receiver, ReceiverListResponse, ReceiverQueryParams, RegisterReceiver } from '@frontend/push-notification/types';

export class PushNotificationReceiverClient extends APIClient {
    public static readonly endpoint = '/push-notification-api/v1';

    public static async fetchPushNotificationReceivers(): Promise<ReceiverListResponse> {
        return await this.apiPaginated<ReceiverListResponse, ReceiverQueryParams>(`${this.endpoint}/receivers`);
    }

    public static async registerPushNotificationReceiver(receiver: RegisterReceiver): Promise<Receiver> {
        const response = await this.post(`${this.endpoint}/register-receiver`, receiver);
        return await this.handleResponse<Receiver>(response);
    }
}
